import '.a{display:flex;}.ssr-plugin'
import '.l{align-items:center;}.ssr-plugin'
import '.x{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ag{background-color:var(--shades-white);}.ssr-plugin'
import '.b8{min-height:100vh;}.ssr-plugin'
import '.b9{margin-bottom:2rem;}.ssr-plugin'
import '.b7{max-width:77.5rem;}.ssr-plugin'
import '.b6{margin-bottom:5rem;}.ssr-plugin'
import '.ad{align-items:stretch;}.ssr-plugin'
import { ReactNode } from 'react'
import { Style, styled } from 'inlines'
import TopNavBar from '@app/components/blocks/navbar/main/TopNavBar'
import Footer from '@app/components/blocks/footer/Footer'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Head } from '@based/sdk/react'

export const PageLayout = ({
  gap = '1rem',
  standardPageTitle = true,
  children,
  marginTop = '2rem',
  style,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  standardPageTitle?: boolean
  children: ReactNode
  marginTop?: string
  style?: Style
}) => {
  const isMobile = useMediaQuery()
  return (
    <styled.div className="a l x b ag"
      style={{
        ...style,
      }}
    >
      {standardPageTitle && (
        <Head>
          <title>CrowdBuilding</title>
        </Head>
      )}
      <TopNavBar />
      <div className="b8 b9 b7"
        style={{
          width: isMobile ? '100%' : '85%',
          paddingInline: isMobile ? '1rem' : 0,
        }}
      >
        <styled.main className="b6 a b ad"
          style={{
            marginTop,
            gap: gap,
            paddingInline: isMobile ? 0 : '1rem',
          }}
        >
          {children}
        </styled.main>

        <Footer />
      </div>
    </styled.div>
  )
}
